import React from 'react';

const SvgRectangleLegend = (props) => (
  <svg width={20} height={10} {...props}>
    <g fill="none">
      <rect width={20} height={1} y={4.5} fill={props.color} rx={0.5} />
      <path
        fill="#FFF"
        stroke={props.color}
        strokeWidth={2}
        d="M6.338 1h8v8h-8z"
      />
    </g>
  </svg>
);

export default SvgRectangleLegend;
